import CombinedAttributesMixin from '@intercom/embercom-composer/components/mixins/combined-attributes';
import $ from 'jquery';
import Em from 'ember';
export default Em.Component.extend(CombinedAttributesMixin, {
  html: '',
  isAttributeSelectorVisible: false,
  attributePlaceholder: 'REPLACE_THIS',
  classNames: ['composer-html-editor-textarea-container'],
  classNameBindings: ['hasError:o__error'],
  attributeBindings: ['style'],
  hasError: false,
  focusAttribute() {
    let startCaretPosition;
    let endCaretPosition;
    let attributePlaceholder = this.get('attributePlaceholder');
    let attributeEndPosition = this.get('attributeEndPosition');
    let placeholderInsertionPoint = this.get('placeholderInsertionPoint');
    if (placeholderInsertionPoint >= 0) {
      startCaretPosition = placeholderInsertionPoint;
      endCaretPosition = placeholderInsertionPoint + attributePlaceholder.length;
    } else {
      startCaretPosition = attributeEndPosition;
      endCaretPosition = attributeEndPosition;
    }
    this.placeCaretInTextarea(startCaretPosition, endCaretPosition);
  },
  placeholderInsertionPoint: Em.computed('newlyInsertedAttribute', function () {
    let placeholder = this.get('attributePlaceholder');
    let newlyInsertedAttribute = this.get('newlyInsertedAttribute');
    let hasAttributeFallback = newlyInsertedAttribute.indexOf(placeholder) > -1;
    let indexOfPlaceholderInAttribute = newlyInsertedAttribute.indexOf(placeholder);
    let indexOfPlaceholderInTextarea = this.get('attributeStartPosition') + indexOfPlaceholderInAttribute;
    return hasAttributeFallback ? indexOfPlaceholderInTextarea : -1;
  }),
  newlyInsertedAttribute: Em.computed('attributeStartPosition', 'attributeEndPosition', function () {
    if (!$('textarea', this.element).length) {
      return '';
    }
    return $('textarea', this.element)[0].value.substring(this.get('attributeStartPosition'), this.get('attributeEndPosition'));
  }),
  placeCaretInTextarea(start, end) {
    $('textarea', this.element)[0].setSelectionRange(start, end);
  },
  createAttributeTemplate(attribute) {
    let template;
    if (attribute.get('noFallback')) {
      template = `{{ ${attribute.get('templatable_identifier')} }}`;
    } else {
      template = `{{ ${attribute.get('templatable_identifier')} | fallback: "${this.get('attributePlaceholder')}" }}`;
    }
    return template;
  },
  addAttributeToTextarea(attribute) {
    let $textarea = $('textarea', this.element);
    $textarea.focus();
    let caretPosition = $textarea[0].selectionStart;
    let currentText = $textarea.val();
    let attributeTemplate = this.createAttributeTemplate(attribute);
    this.set('attributeStartPosition', caretPosition);
    this.set('attributeEndPosition', caretPosition + attributeTemplate.length);
    $textarea.val(currentText.substring(0, caretPosition) + attributeTemplate + currentText.substring(caretPosition));
  },
  click(e) {
    let $target = $(e.target);
    if (this.get('isAttributeSelectorVisible') && !$target.closest('.js__attribute-container, .has-expander').length) {
      this.set('isAttributeSelectorVisible', false);
    }
  },
  actions: {
    insertAttribute(attribute) {
      this.addAttributeToTextarea(attribute);
      this.focusAttribute();
      this.set('isAttributeSelectorVisible', false);
    },
    toggleAttributeSelector() {
      this.toggleProperty('isAttributeSelectorVisible');
    }
  }
});